import XIcon from '@mui/icons-material/X'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import icons from '../../../lib/Icons'

const StyledSvg = styled.svg`
  display: inline;
  vertical-align: bottom;
`

const StyledPath = styled.path`
  fill: ${(props) => props.color};
`

const Icon = (props) => {
  let name
  if (props.showName) {
    name = <p>{props.icon}</p>
  }

  return (
    <>
      {props.icon === 'twitter' ? (
        <XIcon
          sx={{
            color: 'twitter',
            height: `${props.size}px`,
            width: `${props.size}px`,
          }}
        />
      ) : (
        <StyledSvg
          height={`${props.size}px`}
          viewBox={`${props.viewBox}`}
          width={`${props.size}px`}
        >
          <StyledPath color={props.color} d={icons[props.icon]} />
        </StyledSvg>
      )}
      {name}
    </>
  )
}

Icon.propTypes = {
  color: PropTypes.string,
  icon: PropTypes.string.isRequired,
  showName: PropTypes.bool,
  size: PropTypes.number,
  viewBox: PropTypes.string,
}

Icon.defaultProps = {
  icon: '',
  color: 'black',
  showName: false,
  size: 50,
  viewBox: '0 0 800 1024',
}

export default Icon
